import React from 'react';
import style from './Header.module.css';
import {NavLink} from "react-router-dom";
import Container from "react-bootstrap/Container";
import SvgLogo from '../../assets/images/logo.svg';
import useIsuUser from "../../api/isu-user";


const Header = () => {
    const user = useIsuUser();

    return (
        <header className={style.header}>
            <div className={style.headerTop}>
                <Container>
                    <div className={style.bar}>
                        <NavLink to={'/'} className={style.logoLink} aria-label="На главную">
                            <img className={style.logo} src={SvgLogo} alt="ГГНТУ"/>
                        </NavLink>
                        <NavLink to={'/'} className={style.siteName}>ЭБС ГГНТУ «Digital Book»</NavLink>
                        <div className={style.user}>
                            {user ? <><i className="fa fa-user" aria-hidden="true"></i> {user.username}</> : null}
                        </div>
                    </div>
                </Container>
            </div>
        </header>
    )
};

export default Header;
